<script>
// import Service from '../../services/jetty';
// import CommonService from '../../services/common';
import Service from '../../services/movement-instruction';

import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';
// import config from '../../common/genericPanelConf';

import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
// import DataTable from 'primevue/datatable';
// import Column from 'primevue/column';
// import Checkbox from 'primevue/checkbox';

// import GenericDataTable from '../../components/generic/GenericDataTable.vue'
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue'
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import GenericDateTimeMaskV2 from '../../components/generic/GenericDateTimeMaskV2.vue';

import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { watch } from 'vue';

export default{
    setup: () => ({ v$: useVuelidate() }),
  components: {
    InputText,
    DataTable,
    Column,
    Button,
    GenericCustomMasterDataAutocompleteV2,
    Dialog, 
    GenericDateTimeMaskV2
},
  data(){
    return {
      loading: false,
      filter: {
        idMovementInstructionHeader: null,
        total: 0
      },
      data: [],
      params: {
      },
      addEtaVisible: false,
      record: {
        id: null,
        idMovementInstructionHeader: null,
        // etaNumber: 0,
        eta: new Date(),
        notifyDate: new Date(),
        notifyMeans: "",
        isDeleted: false
      },
      onlyOpened: true,
      submitted: false
    }
  },
  validations(){
    return {
      record: {
        eta: {required},
        notifyDate: {required},
        notifyMeans: {required},
      }
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    }
  },
  created(){
    // this.timesheetConfiguration = config.getConfiguration('Timesheet');
  },
  mounted(){
    this.$store.dispatch('security/setNavbarTitle', 'movementInstructions.eta');
    if(this.$route.query.id){
      this.filter.idMovementInstructionHeader = this.$route.query.id;
      this.loadData();
    }
  },
  watch: {
    onlyOpened(){
      this.$refs.voyagesCombo.forceLoadOptions("movement-instruction/voyage-number-combo?transportType=N,B&onlyOpened=" + this.onlyOpened)
    }
  },
  methods: {
    loadData(){
      let filters = [];
      filters.push({
          operator: 'eq',
          value: this.filter.idMovementInstructionHeader,
          property: 'IdMovementInstructionHeader'
      });
      filters.push({
          operator: 'eq',
          value: false,
          property: 'IsDeleted'
      });

      this.params.filter = JSON.stringify(filters);
      this.loading = true;
      Service.getEta(this.params, response => {
        
          this.loading = false;
          if(response.success){
              this.data = response.data;
              this.total = response.totalCount;
          }
      });
    },
    addRecord(){
      this.addEtaVisible = true;
      this.record = {
        id: null,
        idMovementInstructionHeader: this.filter.idMovementInstructionHeader,
        // etaNumber: 0,
        eta: new Date(),
        notifyDate: new Date(),
        notifyMeans: "",
        isDeleted: false
      };
    },
    onUpdate(data){
      this.record = {...data};
      this.addEtaVisible = true;
    },
    onDelete(data){
      this.$confirm.require({
        message: this.$t('messages.delete_message_question'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        accept: () => {
            Service.deleteEta(data.id, response => {
              if(response.success){
                  this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                  this.loadData();
              }else{
                  this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            })
        },
        reject: () => {
            //callback to execute when user rejects the action
        }
      });
    },
    onVoyageSelected(){
      this.loadData();
    },
    saveEta(){
      this.submitted = true;
      if(!this.v$.record.$invalid){
        if(this.record.id == null){
          Service.createEta(this.record, response => {
            if(response.success){
                this.addEtaVisible = false;
                this.record = {};
                this.loadData();
                this.submitted = false;
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
            }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
          });
        }else{
          Service.updateEta(this.record, response => {
            if(response.success){
                this.addEtaVisible = false;
                this.record = {};
                this.loadData();
                this.submitted = false;
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
            }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
          });
        }
    }
    }
  }
}

</script>

<template>
  <main>
    <div class="m-5">
      <div class="grid">
        <div class="col-12 lg:col-4 field">
          <label for="voyages">{{$t('timesheet.voyage')}}</label>
          <GenericCustomMasterDataAutocompleteV2
            ref="voyagesCombo"
            :changeFn="onVoyageSelected"
            v-model="filter.idMovementInstructionHeader"
            :queryField="{getOnlyOpened: onlyOpened, transportType: 'N,B'}"
            name="voyages-combo-for-eta" 
            id="voyages"
            api="movement-instruction/voyage-number-combo?onlyOpened=true&transportType=N,B"
            class="w-full p-inputtext-sm" />
            <div>
              <Checkbox
              v-model="onlyOpened" 
              :binary="true" 
              name="onlyOpened"
              class="mt-2 mr-2"/>
              <label for="onlyOpened">{{$t('timesheet.onlyOpenedVoyage')}}</label>  
            </div>
        </div>
        <div class="col-12">
          <Button :label="$t('btn.add')" icon="pi pi-plus" class="m-4 p-button-outlined" @click="addRecord" :disabled="!uiPermissions('EtaAddButton').isEnabled || filter.idMovementInstructionHeader == null" v-if="!uiPermissions('EtaAddButton').isHidden"/>
          <DataTable style="height: 26vw" :loading="loading" :reorderableColumns="true"
            :value="data" :lazy="true" showGridlines stripedRows  ref="dt" :resizableColumns="true" columnResizeMode="expand">
              <Column :exportable="false" :reorderableColumn="false" v-if="!uiPermissions('EtaEditButton').isHidden || !uiPermissions('EtaDeleteButton').isHidden">
                <template #body="slotProps">
                    <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" v-tooltip="$t('btn.edit')" @click="onUpdate(slotProps.data)" :disabled="!uiPermissions('EtaEditButton').isEnabled" v-if="!uiPermissions('EtaEditButton').isHidden"/>
                    <Button icon="pi pi-trash" class="p-button-rounded p-button-warning mr-2" v-tooltip="$t('btn.delete')" @click="onDelete(slotProps.data)" :disabled="!uiPermissions('EtaDeleteButton').isEnabled" v-if="!uiPermissions('EtaDeleteButton').isHidden"/>
                </template>
              </Column>
              <Column :header="$t('movementInstructions.etaNumber')"
                  field="etaNumber" dataType="number">
                  <template #body="element">
                      {{element.data.etaNumber}}
                  </template>
              </Column>
              <Column :header="$t('movementInstructions.eta')"
                  field="eta" dataType="date">
                  <template #body="element">
                      {{element.data.eta != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.eta)) : null}}
                  </template>
              </Column>
              <Column :header="$t('movementInstructions.notifyDate')"
                  field="notifyDate" dataType="date">
                  <template #body="element">
                      {{element.data.notifyDate != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.notifyDate)) : null}}
                  </template>
              </Column>
              <Column :header="$t('movementInstructions.notifyMeans')"
                  field="notifyMeans" dataType="string">
                  <template #body="element">
                      {{element.data.notifyMeans}}
                  </template>
              </Column>
              <template #empty>
                  {{$t('noRecordsFound')}}
              </template>
            </DataTable>

            <Dialog v-model:visible="addEtaVisible" :style="{width: '450px'}" :modal="true" class="p-fluid">
                <!-- <div class="field">
                    <label for="etaNumber">{{$t('movementInstructions.etaNumber')}}</label>
                    <InputText id="etaNumber" v-model="editingData.etaNumber" required="true" autofocus type="number"/>
                </div> -->
                <div class="field">
                  <label for="eta" :class="{'p-error':v$.record.eta.$invalid && submitted}">{{$t('movementInstructions.eta')}}</label>
                  <GenericDateTimeMaskV2
                          v-model="record.eta" 
                          mask="99/99/9999 99:99"
                          :unmask="true"
                          class="w-full p-inputtext-sm mt-1" /> 
                  <div v-if="(v$.record.eta.$invalid && submitted) || v$.record.eta.$pending.$response">
                    <small class="p-error" v-for="error in v$.record.eta.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                  </div>
                </div>
                <div class="field">
                  <label for="notifyDate" :class="{'p-error':v$.record.notifyDate.$invalid && submitted}">{{$t('movementInstructions.notifyDate')}}</label>
                    <GenericDateTimeMaskV2 
                          v-model="record.notifyDate" 
                          mask="99/99/9999 99:99"
                          :unmask="true"
                          class="w-full p-inputtext-sm mt-1" /> 
                  <div v-if="(v$.record.notifyDate.$invalid && submitted) || v$.record.notifyDate.$pending.$response">
                    <small class="p-error" v-for="error in v$.record.notifyDate.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                  </div>
                </div>
                <div class="field">
                  <label for="notifyMeans" :class="{'p-error':v$.record.notifyMeans.$invalid && submitted}">{{$t('movementInstructions.notifyMeans')}}</label>
                  <InputText id="notifyMeans" v-model="record.notifyMeans" required="true" autofocus type="string"/>
                  <div v-if="(v$.record.notifyMeans.$invalid && submitted) || v$.record.notifyMeans.$pending.$response">
                    <small class="p-error" v-for="error in v$.record.notifyMeans.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                  </div>
                </div>
                <template #footer>
                    <!-- <Button :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text" @click="editingDataVisible = false"/> -->
                    <Button :label="$t('btn.save')" icon="pi pi-check" class="p-button-text" @click="saveEta" />
                </template>
            </Dialog>

        </div>
      </div>
    </div>
  </main>
</template>